import styled from "styled-components";

export const AccordionContainer = styled.div`
  position: relative;

  width: 100%;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  row-gap: 40px; // ?

  font-family: ${({ theme }) => theme.fontFamilies.secondary};

  padding: 16px 0;
  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-template-columns: repeat(12, 1fr);

    padding: 0;
  }
`;

export const AccordionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${({ theme }) => theme.mediaQueries.tablet} {
    grid-column: 3 / span 8;
  }
`;
